/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_App_Join_CountInputs */

const en_marketing_app_join_count = /** @type {(inputs: Marketing_App_Join_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join 50,000+`)
};

const es_marketing_app_join_count = /** @type {(inputs: Marketing_App_Join_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Únete a más de 50,000`)
};

/**
* | output |
* | --- |
* | "Join 50,000+" |
*
* @param {Marketing_App_Join_CountInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const marketing_app_join_count = /** @type {((inputs?: Marketing_App_Join_CountInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_App_Join_CountInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_marketing_app_join_count(inputs)
	return en_marketing_app_join_count(inputs)
});